$(document).ready(function () {
  $("#CartDrawer-Note").val("");
  $("#Cart-note").val("");

  // if (!window.location.pathname.includes("collections/all")) {
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(0)
  //     .css("display", "none");
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(0)
  //     .removeAttr("open");
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(1)
  //     .attr("open", true);
  //   $("#FacetFiltersForm > #FacetsWrapperDesktop > details")
  //     .eq(1)
  //     .find("summary")
  //     .attr("aria-expanded", "true");
  // }

  //collection
  $(document).on("click", ".shopify-buy-it-now", function (e) {
    $("#modal-popup-buyitnow.overlay")
      .css("visibility", "visible")
      .css("opacity", "1");
    $("body").addClass("modal-open"); // Disable scroll
    $("#variant_id").val($(this).data("key"));
    $("#product_quantity").val(e.target.form[4].value);
    $("#CartDrawer-Note-modal").val("");

    var amount = $(this).data("a");

    if ($("." + $(this).data("key") + "> .axt_discounted_price").length) {
      var temp = $("." + $(this).data("key") + "> .axt_discounted_price")
        .text()
        .replace(/[^0-9.-]+/g, "");
      var amount = parseFloat(temp).toFixed(2);
    }

    if (window.customer) {
      var hasEmployee;
      const input = window.customerTags;
      if (input.length > 0) {
        hasEmployee = input.some(item => item.toLowerCase() === "employee");
      } else {
        hasEmployee = false;
      }

      if (hasEmployee) {
        if ($(this).data("p") != "" && $(this).data("p") != 0.0) {
          if (amount * $("#product_quantity").val() > $(this).data("p")) {
            $(".note-error").text("You exceeded your purchase limit.");
            $(".note-error").removeAttr("hidden");
            $(".continue-checkout").attr("disabled", "disabled");
          } else {
            $(".note-error").attr("hidden", "true");
            $(".continue-checkout").removeAttr("disabled");
          }
        } else {
          $(".note-error").text(
            "Please indicate the purchase limit of the employee"
          );
          $(".note-error").removeAttr("hidden");
          $(".continue-checkout").attr("disabled", "disabled");
        }
      } else {
        $(".cart-pu-location").remove();
        $("#pu-location-modal").remove();
        $(".note-error").attr("hidden", "true");
        $(".continue-checkout").removeAttr("disabled");

        if ($(".custom-message").length === 0) {
          $("cart-note.cart__note.field").before(`
              <div class="custom-message">
                  <h4 class="p-pu-popup-title" style="border: 1px solid #000; font-weight: bold !important;"><img src="https://cdn.shopify.com/s/files/1/0677/4423/5717/files/DeliveryIcon.svg?v=1748493486" width="40" height="auto" style="padding-right: 10px; filter: invert(1);" alt="truck-icon"> Delivery & Pickup Information</h4>
                <div>
                  <h4>Metro Manila Delivery Fee:</h4>
                  <p>FREE for Metro Manila customers.</p>
                  <h4>Non-Metro Manila Customers:</h4>
                  <p>Non-Metro Manila customers must arrange their own pickup.</p>
                  <h4 class="p-pu-popup-title" style="border: 1px solid #000;"><img src="https://cdn.shopify.com/s/files/1/0895/1087/1331/files/clarity--map-marker-line.png?v=1726463350" width="20px" height="20px" style="margin-right: 5px;"> Pickup Location</h4>
                  <p class="p-pu-popup-text">Krieger's Sheridan: 17 Sheridan, Mandaluyong City, Metro Manila</p>
                </div>
              </div>
          `);
        }
      }
    } else {
      $(".cart-pu-location").remove();
      $("#pu-location-modal").remove();
      $(".note-error").text("Please login first to transact.");
      $(".note-error").removeAttr("hidden");
      $(".continue-checkout").attr("disabled", "disabled");
    }
  });

  //product page
  $(document).on("click", ".shopify-buy-it-now-product", function (e) {
    $("#modal-popup-buyitnow.overlay")
      .css("visibility", "visible")
      .css("opacity", "1");
    $("body").addClass("modal-open"); // Disable scroll
    $("#variant_id").val($(this).data("key"));
    $("#product_quantity").val(e.target.form[1].value);
    $("#CartDrawer-Note-modal").val("");

    var amount = $(this).data("a");

    if ($("." + $(this).data("key") + "> .axt_discounted_price").length) {
      var temp = $("." + $(this).data("key") + "> .axt_discounted_price")
        .text()
        .replace(/[^0-9.-]+/g, "");
      var amount = parseFloat(temp).toFixed(2);
    }

    if (window.customer) {
      var hasEmployee;
      const input = window.customerTags;
      if (input.length > 0) {
        hasEmployee = input.some(item => item.toLowerCase() === "employee"); 
      } else {
        hasEmployee = false;
      }

      if (hasEmployee) {
        if ($(this).data("p") != "" && $(this).data("p") != 0.0) {
          if (amount * $("#product_quantity").val() > $(this).data("p")) {
            $(".note-error").text("You exceeded your purchase limit.");
            $(".note-error").removeAttr("hidden");
            $(".continue-checkout").attr("disabled", "disabled");
          } else {
            $(".note-error").attr("hidden", "true");
            $(".continue-checkout").removeAttr("disabled");
          }
        } else {
          $(".note-error").text(
            "Please indicate the purchase limit of the employee"
          );
          $(".note-error").removeAttr("hidden");
          $(".continue-checkout").attr("disabled", "disabled");
        }
      } else {
        $(".cart-pu-location").remove();
        $("#pu-location-modal").remove();
        $(".note-error").attr("hidden", "true");
        $(".continue-checkout").removeAttr("disabled");

        if ($(".custom-message").length === 0) {
          $("cart-note.cart__note.field").before(`
              <div class="custom-message">
                <h4 class="p-pu-popup-title" style="border: 1px solid #000;"><img src="https://cdn.shopify.com/s/files/1/0895/1087/1331/files/clarity--map-marker-line.png?v=1726463350" width="20px" height="20px" style="margin-right: 5px;"> Pickup Location</h4>
                <p class="p-pu-popup-text">Krieger's Sheridan: 17 Sheridan, Mandaluyong City, Metro Manila</p>
                <div>
                  <h4>Metro Manila Delivery Fee:</h4>
                  <p>FREE for Metro Manila customers.</p>
                  <h4>Non-Metro Manila Customers:</h4>
                  <p>Non-Metro Manila customers must arrange their own pickup.</p>
                </div>
              </div>
          `);
        }
      }
    } else {
      $(".cart-pu-location").remove();
      $("#pu-location-modal").remove();
      $(".note-error").text("Please login first to transact.");
      $(".note-error").removeAttr("hidden");
      $(".continue-checkout").attr("disabled", "disabled");
    }
  });

  $(document).on("click", ".continue-checkout", function (e) {
    var buyitnow_details = {
      id: $("#variant_id").val(),
      quantity: $("#product_quantity").val(),
    };

    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      data: "",
      dataType: "json",
      success: function () {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(buyitnow_details),
        })
          .then((response) => response.json())
          .then((cart) => {
            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                var hasEmployee;
                const input = window.customerTags;
                if (input.length > 0) {
                  hasEmployee = input.some(item => item.toLowerCase() === "employee");
                } else {
                  hasEmployee = false;
                }

                if (hasEmployee) {
                  var updateData = {
                    note:
                      "Pickup Location: \r\n" +
                      document.getElementById("pu-location-modal").value +
                      "\r\n\r\nInstruction: \r\n" +
                      document.getElementById("CartDrawer-Note-modal").value,
                    updates: {}, // Include any cart updates if necessary
                  };
                } else {
                  var updateData = {
                    note:
                      "Instruction: \r\n" +
                      document.getElementById("CartDrawer-Note-modal").value,
                    updates: {}, // Include any cart updates if necessary
                  };
                }

                // Update cart with note
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify(updateData),
                })
                  .then((response) => response.json())
                  .then((cart) => {
                    window.location.href = "/checkout";
                  })
                  .catch((error) => {
                    console.error("Error updating cart note:", error);
                  });
              })
              .catch((error) => {
                console.error("Error fetching cart:", error);
              });
          })
          .catch((error) => {
            console.error("Error adding item to cart:", error);
          });
      },
      error: function (XMLHttpRequest, textStatus) {},
    });
  });

  $(".close-modal").on("click", function (e) {
    $("#modal-popup-buyitnow.overlay")
      .css("visibility", "hidden")
      .css("opacity", "0");
    $("body").removeClass("modal-open"); // Enable scroll
  });

  $(".close-modal-ann").click(function () {
    $("#announcement-container").hide();
  });

  if ($('.collection--empty').length) {
    $('aside#main-collection-filters').hide();
  }
  
});

var swiper = new Swiper(".announcement-container.employee", {
  speed: 400,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    enabled: false,
  }
});

var swiper = new Swiper(".promo-employee", {
  speed: 800,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".banner-promo-next",
    prevEl: ".banner-promo-prev",
  },
});

var swiper = new Swiper(".swiper-container-category", {
  slidesPerView: 3,
  spaceBetween: 10,
  freeMode: true,
  loop: true,
  simulateTouch: true,
  allowTouchMove: true,
  navigation: {
    nextEl: ".category-next",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    991: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 6,
    },
    1920: {
      slidesPerView: 6,
    },
  },
});

var swiper = new Swiper(".swiper-featured-collection-no-bg", {
  speed: 400,
  spaceBetween: 10,
  slidesPerView: 2,
  loop: true,
  simulateTouch: true,
  allowTouchMove: true,
  navigation: {
    nextEl: ".featured-no-bg-next",
    prevEl: ".featured-no-bg-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".featured-collection-with-bg", {
  speed: 400,
  spaceBetween: 10,
  slidesPerView: 2,
  loop: true,
  simulateTouch: true,
  allowTouchMove: true,
  navigation: {
    nextEl: ".featured-wth-bg-next",
    prevEl: ".featured-wth-bg-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".featured-related-products", {
  speed: 400,
  spaceBetween: 10,
  slidesPerView: 2,
  loop: true,
  navigation: {
    nextEl: ".featured-rel-prod-next",
    prevEl: ".featured-rel-prod-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  showAnnouncement();
  if (window.location.href.indexOf("/collections/new-products") !== -1) {
    const facetsWrapper = document.querySelectorAll(".facets-wrapper");
    if (facetsWrapper.length > 0) {
      facetsWrapper[0].style.display = "none";
    }
  }

  const cart = document.querySelector("cart-drawer");
  const options = {
    attributes: true,
  };

  function callback(mutationList, observer) {
    mutationList.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        $("#CartDrawer-Note").val("");
      }
    });
  }

  const observer = new MutationObserver(callback);
  observer.observe(cart, options);
});

function setCookie(cname, cvalue) {
  const d = new Date();
  d.setTime(d.getTime() + 30 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function showAnnouncement() {
  let token = getCookie("pop-annon");
  if (token == 0) {
    $("#announcement-container").attr(
      "style",
      "display:block !important; visibility: visible !important"
    );
    setCookie("pop-annon", 1);
  } else {
    $("#announcement-container").attr(
      "style",
      "display:none !important; visibility: hidden !important"
    );
  }
}
